import React from 'react';
import { Link } from 'react-router-dom';
import { FaCalendarAlt, FaClock, FaMapMarkerAlt, FaUsers, FaTrophy, FaArrowRight } from 'react-icons/fa';
import './Events.css';

const Events = () => {
  const upcomingEvents = [
    {
      id: 1,
      title: 'Intra-Club Badminton Tournament',
      date: 'January 15-16, 2026',
      time: '9:00 AM - 6:00 PM',
      location: 'Net Nest Main Hall',
      description: 'This event is organized exclusively for Net Nest members. It allows players to compete with fellow trainees in a friendly yet competitive environment. The tournament helps players apply their training in real match situations and gain confidence.',
      participants: '128 spots',
      fee: '$45',
      image: 'https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=600',
      featured: true
    },
    {
      id: 2,
      title: 'Junior Badminton Championship',
      date: 'January 22, 2026',
      time: '10:00 AM - 12:00 PM',
      location: 'Courts 1-4',
      description: 'Designed for young players, this championship encourages early competitive exposure. Age-wise categories ensure fair play while helping children develop discipline, confidence, and sportsmanship.',
      participants: '24 spots',
      fee: 'Free',
      image: 'img/Junior Badminton Championship.jpg',
      featured: false
    },
    {
      id: 3,
      title: 'Open Badminton Tournament',
      date: 'February 5, 2026',
      time: '1:00 PM - 5:00 PM',
      location: 'Net Nest Main Hall',
      description: 'The Open Badminton Tournament welcomes players from other clubs and academies. This event provides high-level competition, helping our players measure their skills against different playing styles.',
      participants: '32 players',
      fee: 'Free to watch',
      image: 'img/Open Badminton Tournament.jpg',
      featured: false
    },
    {
      id: 4,
      title: 'Doubles & Mixed Doubles Event',
      date: 'February 12, 2026',
      time: '6:00 PM - 9:00 PM',
      location: 'All Courts',
      description: 'This event focuses on teamwork, coordination, and communication. Players learn positioning, rotation, and partner understanding while enjoying exciting doubles matches.',
      participants: '48 spots',
      fee: '$15',
      image: 'img/Doubles & Mixed Doubles Event.jpg',
      featured: false
    },
    {
      id: 5,
      title: 'Friendly Match Series',
      date: 'February 20, 2026',
      time: '2:00 PM - 5:00 PM',
      location: 'Courts 9-12',
      description: 'Friendly matches are organized regularly to help players gain match experience without pressure. These events focus on learning, strategy testing, and building confidence.',
      participants: '16 spots',
      fee: '$60',
      image: 'img/Friendly Match Series.jpg',
      featured: false
    },
    {
      id: 6,
      title: 'Fitness & Endurance Challenge',
      date: 'March 8-9, 2026',
      time: '9:00 AM - 7:00 PM',
      location: 'Net Nest Main Hall',
      description: 'This special event emphasizes physical conditioning. Players participate in agility drills, endurance exercises, and fitness challenges designed to improve stamina and overall athletic performance.',
      participants: '96 spots',
      fee: '$50',
      image: 'img/Fitness & Endurance Challenge.jpg',
      featured: false
    },
    {
      id: 7,
      title: 'Youth Talent Identification Camp',
      date: 'March 16-22, 2026',
      time: '9:00 AM - 7:00 PM',
      location: 'Net Nest Main Hall',
      description: 'This event is aimed at discovering young badminton talent. Coaches assess skills, movement, and potential, providing guidance for further development and training opportunities.',
      participants: '96 spots',
      fee: '$50',
      image: 'img/Youth Talent Identification Camp.jpg',
      featured: false
    },
    {
      id: 8,
      title: 'Coaching & Skill Development Workshop',
      date: 'April 8-11, 2026',
      time: '9:00 AM - 7:00 PM',
      location: 'Net Nest Main Hall',
      description: 'Special workshops are conducted to focus on specific aspects of the game such as footwork, smash technique, net play, and match strategies. These sessions enhance technical understanding and skill refinement.',
      participants: '96 spots',
      fee: '$50',
      image: 'img/Coaching & Skill Development Workshop.jpg',
      featured: false
    },
    {
      id: 9,
      title: 'School-Level Badminton Meet',
      date: 'April 20-25, 2026',
      time: '9:00 AM - 7:00 PM',
      location: 'Net Nest Main Hall',
      description: 'Net Nest organizes and participates in school-level badminton meets, encouraging student players to gain competitive exposure and represent their institutions confidently.',
      participants: '96 spots',
      fee: '$50',
      image: 'img/School-Level Badminton Meet.jpg',
      featured: false
    },
    {
      id: 10,
      title: 'Parents–Players Interaction Event',
      date: 'May 1-2, 2026',
      time: '9:00 AM - 7:00 PM',
      location: 'Net Nest Main Hall',
      description: 'This event promotes transparent communication between coaches, players, and parents. Progress reports, feedback, and future training plans are discussed to support player development.',
      participants: '96 spots',
      fee: '$50',
      image: 'https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=600',
      featured: false
    },
    {
      id: 11,
      title: 'Annual Awards & Recognition Ceremony',
      date: 'May 9, 2026',
      time: '9:00 AM - 7:00 PM',
      location: 'Net Nest Main Hall',
      description: 'Outstanding players are recognized for their dedication, improvement, and achievements. Awards motivate players and celebrate hard work, discipline, and sportsmanship.',
      participants: '96 spots',
      fee: '$50',
      image: 'https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=600',
      featured: false
    },
    {
      id: 12,
      title: 'Badminton Awareness & Community Event',
      date: 'June 1-9, 2026',
      time: '9:00 AM - 7:00 PM',
      location: 'Net Nest Main Hall',
      description: 'This event focuses on promoting badminton within the local community. Demonstration matches, fitness awareness, and interaction sessions inspire more people to take up the sport.',
      participants: '96 spots',
      fee: '$50',
      image: 'https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=600',
      featured: false
    }
  ];

  const pastEvents = [
    {
      title: 'Fall Championship 2024',
      date: 'November 15-16, 2024',
      participants: 112,
      image: 'https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=300'
    },
    {
      title: 'Halloween Social Night',
      date: 'October 31, 2024',
      participants: 64,
      image: 'https://images.unsplash.com/photo-1599474924187-334a4ae5bd3c?w=300'
    },
    {
      title: 'Junior Summer Camp',
      date: 'July 15-19, 2024',
      participants: 48,
      image: 'https://images.unsplash.com/photo-1613918431703-aa50889e3be6?w=300'
    }
  ];

  const categories = ['All', 'Tournament', 'Workshop', 'Social'];
  const [activeCategory, setActiveCategory] = React.useState('All');

  const filteredEvents = activeCategory === 'All'
    ? upcomingEvents
    : upcomingEvents.filter(e => e.category === activeCategory);

  return (
    <div className="events-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="page-header-overlay"></div>
        <div className="container">
          <div className="page-header-content">
            <span className="page-badge">Events</span>
            <h1>Upcoming Events</h1>
            <p>Tournaments, workshops, and social gatherings at Net Nest</p>
            <nav className="breadcrumb">
              <Link to="/">Home</Link>
              <span>/</span>
              <span>Events</span>
            </nav>
          </div>
        </div>
      </section>

      {/* Featured Event */}
      <section className="featured-event section">
        <div className="container">
          <div className="featured-event-card">
            <div className="featured-event-image">
              <img src={upcomingEvents[0].image} alt={upcomingEvents[0].title} />
            </div>
            <div className="featured-event-content">
              <h2>{upcomingEvents[0].title}</h2>
              <p>{upcomingEvents[0].description}</p>
              <div className="event-details">
                <div className="detail">
                  <FaCalendarAlt />
                  <span>{upcomingEvents[0].date}</span>
                </div>
                <div className="detail">
                  <FaClock />
                  <span>{upcomingEvents[0].time}</span>
                </div>
              </div>
              <div className="event-footer">
                <Link to="/contact" className="btn btn-primary">Register Now <FaArrowRight /></Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Events Grid */}
      <section className="events-main section">
        <div className="container">
          <div className="events-grid-page">
            {filteredEvents.slice(1).map((event) => (
              <div className="event-card-page" key={event.id}>
                <div className="event-image">
                  <img src={event.image} alt={event.title} />
                </div>
                <div className="event-content">
                  <h3>{event.title}</h3>
                  <p>{event.description}</p>
                  <div className="event-info">
                    <span><FaCalendarAlt /> {event.date}</span>
                    <span><FaClock /> {event.time}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Events;
